module.exports = __webpack_public_path__ + "static/media/email_1.47708080.svg";